import Pusher from "pusher-js";

//Pusher.logToConsole = true;
var pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY || "", {
  cluster: "ap1",
  authEndpoint: `${process.env.REACT_APP_BASEURL}pusher/auth`,
});

export default pusher;
